import cx from 'classnames'
import type { ComponentProps } from 'react'

import type { ErrorFallback } from '../../feedback/errorFallback/ErrorFallback'
import { paperStyles } from '../../libs'
import { Stack } from '../stack/Stack'

type Props = {
  ErrorFallback?: typeof ErrorFallback
  outerClassName?: string
  innerClassName?: string
} & Pick<
  ComponentProps<typeof Stack>,
  'gap' | 'padding' | 'children' | 'style' | 'inert'
>

export function CardBody({
  outerClassName,
  innerClassName,
  children,
  gap = 'normal',
  padding = 'normal',
  style,
  inert,
}: Props) {
  return (
    <div
      className={cx(
        'last:grow rounded-lg overflow-hidden flex',
        paperStyles({ ringColor: 'grey', ringPosition: 'outset' }),
        outerClassName,
      )}
    >
      <Stack
        style={style}
        gap={gap}
        padding={padding}
        data-amaze-cardbody
        inert={inert}
        className={cx(
          'overflow-auto flex-col grow',
          'scroll-fade',
          'has-[>[data-amaze-table]:first-child]:pt-0!', // Ensures top padding is removed when a ui-library table is the first child
          'has-[>[data-amaze-table]:last-child]:pb-0!', // Ensures bottom padding is removed when a ui-library table is the last child
          'has-[>[data-amaze-table]]:scroll-fade-b!', // Ensures sticky headers in tables aren't faded
          innerClassName,
        )}
      >
        {children}
      </Stack>
    </div>
  )
}
